import styled from "styled-components";

export const StyledHomePageFlexBackground = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: -1;
    overflow: hidden;

    @media (min-width: 1920px) {
        svg {
            min-height: 219px;
        }
    }
    @media (max-width: 1919px) {
        svg {
            min-height: 195px;
        }
    }
`;
